import { Field } from 'formik';

interface InputCheckboxProps {
  label?: string;
  name: string;
  description?: string;
}

export const InputCheckbox = ({ label, name, description }: InputCheckboxProps) => {
  return (
    <label className="checkbox-wrapper">
      {label && <span className="checkbox-label">{label}</span>}
      <div className="checkbox-input">
        <Field type="checkbox" name={name} />
        {description && <span className="checkbox-description">{description}</span>}
      </div>
    </label>
  );
};
